import React from "react";
import { FaAsterisk } from "react-icons/fa";
import { twMerge } from "tailwind-merge";
export interface RadioOptionModel {
  id: string;
  label: string;
  value: string | number;
}
export interface RadioGroupProps
  extends React.HTMLAttributes<HTMLInputElement> {
  title?: string;
  labelClassName?: string;
  name: string;
  radioOptions: RadioOptionModel[];
  isRequired?: boolean;
}
const RadioGroup: React.FC<RadioGroupProps> = (props) => {
  const {
    radioOptions,
    labelClassName = "",
    title,
    isRequired,
    ...rest
  } = props;
  return (
    <>
      {title ? (
        <div className="flex truncate text-white mb-4">
          <label>{title}</label>
          {isRequired ? (
            <FaAsterisk className="fill-primary-red-50 pt-1" size={12} />
          ) : (
            <></>
          )}
        </div>
      ) : null}
      {radioOptions?.map((option) => {
        const { id, label, value } = option;
        return (
          <div className="flex items-center mb-1" key={id ?? value}>
            <input
              id={`${value}`}
              type="radio"
              value={value}
              // @ts-expect-error We want a default name that can be overridden by the parent component via pros, this ensure flexibility.
              name="default-radio"
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              {...rest}
            />
            <label
              htmlFor={`${value}`}
              className={twMerge(
                "ms-2 font-medium text-dark-purple-50 ",
                labelClassName
              )}
            >
              {label}
            </label>
          </div>
        );
      })}
    </>
  );
};
export default RadioGroup;
